import { Link } from 'react-router-dom';

type Props = {
  current: string;
  tone?: 'light' | 'dark';
};

export default function Breadcrumb({ current, tone = 'light' }: Props) {
  const isDark = tone === 'dark';
  const linkClass = isDark
    ? 'text-cream/70 hover:text-cream transition-colors'
    : 'text-forest-700/70 hover:text-forest-900 transition-colors';
  const currentClass = isDark ? 'text-cream' : 'text-forest-900';
  const sepClass = isDark ? 'text-cream/40' : 'text-forest-700/40';
  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-3 text-xs uppercase tracking-widest-2"
    >
      <Link to="/" className={linkClass}>
        Nativa
      </Link>
      <span aria-hidden className={sepClass}>
        /
      </span>
      <span className={currentClass}>{current}</span>
    </nav>
  );
}
